const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.666,
    height: 20.495,
    viewBox: "0 0 19.666 20.495",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2263",
    transform: "rotate(-90 10.248 10.248)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5161",
    d: "m.8 4.985-.025.005h9.492L7.283 1.87a.843.843 0 0 1 0-1.149l.464-.484a.754.754 0 0 1 1.1 0l5.115 5.336a.841.841 0 0 1 0 1.148l-5.118 5.334a.755.755 0 0 1-1.1 0l-.464-.485a.82.82 0 0 1-.223-.57.794.794 0 0 1 .226-.561L10.3 7.3H.787A.822.822 0 0 1 0 6.471v-.686a.8.8 0 0 1 .8-.8z",
    transform: "translate(6.31 3.687)",
    style: {
      fill: "#313280"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5760",
    width: 19.666,
    height: 2.206,
    rx: 1,
    transform: "rotate(90 1.103 1.103)",
    style: {
      fill: "#313280"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadRed);
export default __webpack_public_path__ + "static/media/Upload-Red.48ddca061f55a37279dcbb6e9c5aa7e4.svg";
export { ForwardRef as ReactComponent };